export default __webpack_public_path__ + "09.01.2017_Press_Release_LifeTime_Interim_Financing_Thiemea7ec4eced03958e17d91aaf35e0b0aa3.pdf";